export default {
  全部番剧: "全部番剧",
  共: "共",
  部: "部",
  编辑精选: "编辑精选",
  筛选: "筛选",
  排序: "排序",
  最新更新: "最新更新",
  评分最高: "评分最高",
  最受欢迎: "最受欢迎",
  类型: "类型",
  地区: "地区",
  年份: "年份",
  状态: "状态",
  全部: "全部",
  连载中: "连载中",
  已完结: "已完结",
  热血: "热血",
  冒险: "冒险",
  搞笑: "搞笑",
  恋爱: "恋爱",
  奇幻: "奇幻",
  科幻: "科幻",
  悬疑: "悬疑",
  治愈: "治愈",
  校园: "校园",
  战斗: "战斗",
  日本: "日本",
  国产: "国产",
  欧美: "欧美",
} as Record<string, string>;